var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ _vm.showAnim ? 'full-spinner--show-anim' : '',
  _vm.done && !_vm.showAnim ? 'full-spinner--hide-anim' : '',
  'full-spinner']},[_c('fai',{staticClass:"full-spinner__spinner full-spinner__spinner-anim",attrs:{"icon":"spinner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }